module.exports = __webpack_public_path__ + "static/media/reach.74372551.svg";